import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Contexto } from '../../models/contexto';

@Component({
  selector: 'app-pie',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.scss']
})
export class PieComponent {
  @Input() modo: string = "asistente";
  @Input() minimizado: boolean = false;
  @Input() public ctx: Contexto;
  @Output("boton_funcion") boton_funcion: EventEmitter<any> = new EventEmitter<any>();

  boton_click() {
    this.boton_funcion.emit();
  }
}
